import React from "react";
import {Grid, Menu, MenuItem} from "@mui/material";
import styled from "styled-components";
import {Colors} from "../../theme/colors";
import {StyledButton} from "../../components/ui-base/button";
import {SubscriptionPlanService} from "../../services/subscription-plan.service";
import {useDispatch, useSelector} from "react-redux";
import {toggleLoader} from "../../store/global/global-slice";
import {SuccessModal} from "../../components/ui-base/success-modal";
import {AuthMeModel} from "../../models/auth-me.model";
import {RootState} from "../../store/root-reducer";
import {useTranslation} from "react-i18next";

const PriceListPage = () => {
    const [basicSubAnchorEl, setBasicSubAnchorEl] = React.useState<null | HTMLElement>(null);
    const [premiumSubAnchorEl, setPremiumSubAnchorEl] = React.useState<null | HTMLElement>(null);
    const [vipSubAnchorEl, setVipSubAnchorEl] = React.useState<null | HTMLElement>(null);
    const [success, setSuccess] = React.useState(false);
    const [successDescription, setSuccessDescription] = React.useState('');
    const dispatch = useDispatch();
    const { t } = useTranslation(['publisher', 'common']);

    const user: AuthMeModel = useSelector(
        (state: RootState) => state.auth.user
    );

    const requestPlan = async (name: 'publisherBasicSubscriptionYear' | 'publisherPremiumSubscriptionYear' | 'publisherVipSubscriptionYear' | 'publisherBasicSubscriptionMonth' | 'publisherPremiumSubscriptionMonth' | 'publisherVipSubscriptionMonth', paymentMethod: 'online' | 'manual') => {
        dispatch(toggleLoader(true));
        const response: any = await SubscriptionPlanService.newSendSubscriptionRequest(name, paymentMethod);

        if (paymentMethod === 'online' && response?.data?.redirectUri) {
            window.open(response.data.redirectUri,'_blank');
            setSuccessDescription(t('priceList.payOnlineSuccess'));
            setSuccess(true);
        }

        if (paymentMethod === 'manual' && response) {
            setSuccessDescription(t('priceList.payManualSuccess'));
            setSuccess(true);
        }

        dispatch(toggleLoader(false));
    }

    return (
        <>
        <Grid container direction={"row"} spacing={2}>
            <Grid item xs={12} sm={4}>
                <StyledTitle>{t('priceList.package.title1')}</StyledTitle>
                <StyledUl>
                    <StyledLi>{t('priceList.package.option1')}</StyledLi>

                    <StyledLi>{t('priceList.package.option2')}</StyledLi>

                    <StyledLi>{t('priceList.package.option3')}</StyledLi>

                    <StyledLi>{t('priceList.package.option4')}</StyledLi>

                    <StyledLi>{t('priceList.package.option5')}</StyledLi>

                    <StyledLi>{t('priceList.package.option6')}</StyledLi>

                    <StyledLi>{t('priceList.package.option7')}</StyledLi>

                    <StyledLi>{t('priceList.package.option8')}</StyledLi>

                    <StyledLiNonActive>{t('priceList.package.option9')}</StyledLiNonActive>

                    <StyledLiNonActive>{t('priceList.package.option10')}</StyledLiNonActive>

                    <StyledLiNonActive>{t('priceList.package.option11')}</StyledLiNonActive>

                    <StyledLiNonActive>{t('priceList.package.option12')}</StyledLiNonActive>

                    <StyledLiNonActive>{t('priceList.package.option13')}</StyledLiNonActive>

                    <StyledLiNonActive>{t('priceList.package.option14')}</StyledLiNonActive>

                    <StyledLiNonActive>{t('priceList.package.option15')}</StyledLiNonActive>

                    <StyledLiNonActive>{t('priceList.package.option16')}</StyledLiNonActive>

                    <StyledLiNonActive>{t('priceList.package.option17')}</StyledLiNonActive>
                </StyledUl>

                <Grid container direction={"column"} justifyContent={"center"} alignItems={"center"}>
                    <StyledPrice>&nbsp;</StyledPrice>
                    <StyledPrice>{t('priceList.package.priceMonth1')}</StyledPrice>
                    <StyledButton type={"button"} color={"violet"} onClick={(event) => {setBasicSubAnchorEl(event.currentTarget)}} disabled={(user?.subscription?.codename === 'publisherBasicSubscriptionYear')}>{t('priceList.orderButton')}</StyledButton>
                    <Menu
                        id="basic-sub-menu"
                        anchorEl={basicSubAnchorEl}
                        open={Boolean(basicSubAnchorEl)}
                        onClose={() => setBasicSubAnchorEl(null)}
                    >
                        {user?.language === 'pl' &&
                            <MenuItem onClick={() => {requestPlan("publisherBasicSubscriptionYear", "online")}}>{t('priceList.payOnlineYear')}</MenuItem>
                        }
                        <MenuItem onClick={() => {requestPlan("publisherBasicSubscriptionYear", "manual")}}>{t('priceList.payManualYear')}</MenuItem>
                    </Menu>
                    {user?.subscription?.codename === 'publisherBasicSubscriptionYear' && user?.subscription?.billing_end &&
                    <StyledDateExpire>{t('priceList.subBillingEnd')}: {new Date(user?.subscription?.billing_end).toLocaleString()}</StyledDateExpire>
                    }
                </Grid>
            </Grid>

            <Grid item xs={12} sm={4}>
                <StyledTitle>{t('priceList.package.title2')}</StyledTitle>
                <StyledUl>
                    <StyledLi>{t('priceList.package.option1')}</StyledLi>

                    <StyledLi>{t('priceList.package.option2')}</StyledLi>

                    <StyledLi>{t('priceList.package.option3')}</StyledLi>

                    <StyledLi>{t('priceList.package.option4')}</StyledLi>

                    <StyledLi>{t('priceList.package.option5')}</StyledLi>

                    <StyledLi>{t('priceList.package.option6')}</StyledLi>

                    <StyledLi>{t('priceList.package.option7')}</StyledLi>

                    <StyledLi>{t('priceList.package.option8')}</StyledLi>

                    <StyledLi>{t('priceList.package.option9')}</StyledLi>

                    <StyledLi>{t('priceList.package.option10')}</StyledLi>

                    <StyledLi>{t('priceList.package.option11')}</StyledLi>

                    <StyledLi>{t('priceList.package.option12')}</StyledLi>

                    <StyledLiNonActive>{t('priceList.package.option13')}</StyledLiNonActive>

                    <StyledLiNonActive>{t('priceList.package.option14')}</StyledLiNonActive>

                    <StyledLiNonActive>{t('priceList.package.option15')}</StyledLiNonActive>

                    <StyledLiNonActive>{t('priceList.package.option16')}</StyledLiNonActive>

                    <StyledLiNonActive>{t('priceList.package.option17')}</StyledLiNonActive>
                </StyledUl>

                <Grid container direction={"column"} justifyContent={"center"} alignItems={"center"}>
                    <StyledPrice>{t('priceList.package.priceMonth2')}</StyledPrice>
                    {/*<StyledPrice>&nbsp;</StyledPrice>*/}
                    <StyledPrice>{t('priceList.package.priceYear2')}</StyledPrice>
                    <StyledButton type={"button"} color={"violet"} onClick={(event) => {setPremiumSubAnchorEl(event.currentTarget)}} disabled={(user?.subscription?.codename === 'publisherPremiumSubscriptionMonth' || user?.subscription?.codename === 'publisherPremiumSubscriptionYear')}>{t('priceList.orderButton')}</StyledButton>
                    <Menu
                        id="premium-sub-menu"
                        anchorEl={premiumSubAnchorEl}
                        open={Boolean(premiumSubAnchorEl)}
                        onClose={() => setPremiumSubAnchorEl(null)}
                    >
                        {user?.language === 'pl' &&
                            <MenuItem onClick={() => {requestPlan("publisherPremiumSubscriptionMonth", "online")}}>{t('priceList.payOnlineMonth')}</MenuItem>
                        }
                        <MenuItem onClick={() => {requestPlan("publisherPremiumSubscriptionMonth", "manual")}}>{t('priceList.payManualMonth')}</MenuItem>
                        {user?.language === 'pl' &&
                            <MenuItem onClick={() => {requestPlan("publisherPremiumSubscriptionYear", "online")}}>{t('priceList.payOnlineYear')}</MenuItem>
                        }
                        <MenuItem onClick={() => {requestPlan("publisherPremiumSubscriptionYear", "manual")}}>{t('priceList.payManualYear')}</MenuItem>
                    </Menu>
                    {(user?.subscription?.codename === 'publisherPremiumSubscriptionMonth' || user?.subscription?.codename === 'publisherPremiumSubscriptionYear') && user?.subscription?.billing_end &&
                    <StyledDateExpire>{t('priceList.subBillingEnd')}: {new Date(user?.subscription?.billing_end).toLocaleString()}</StyledDateExpire>
                    }
                </Grid>
            </Grid>

            <Grid item xs={12} sm={4}>
                <StyledTitle>{t('priceList.package.title3')}</StyledTitle>
                <StyledUl>
                    <StyledLi>{t('priceList.package.option1')}</StyledLi>

                    <StyledLi>{t('priceList.package.option2')}</StyledLi>

                    <StyledLi>{t('priceList.package.option3')}</StyledLi>

                    <StyledLi>{t('priceList.package.option4')}</StyledLi>

                    <StyledLi>{t('priceList.package.option5')}</StyledLi>

                    <StyledLi>{t('priceList.package.option6')}</StyledLi>

                    <StyledLi>{t('priceList.package.option7')}</StyledLi>

                    <StyledLi>{t('priceList.package.option8')}</StyledLi>

                    <StyledLi>{t('priceList.package.option9')}</StyledLi>

                    <StyledLi>{t('priceList.package.option10')}</StyledLi>

                    <StyledLi>{t('priceList.package.option11')}</StyledLi>

                    <StyledLi>{t('priceList.package.option12')}</StyledLi>

                    <StyledLi>{t('priceList.package.option13')}</StyledLi>

                    <StyledLi>{t('priceList.package.option14')}</StyledLi>

                    <StyledLi>{t('priceList.package.option15')}</StyledLi>

                    <StyledLi>{t('priceList.package.option16')}</StyledLi>

                    <StyledLi>{t('priceList.package.option17')}</StyledLi>
                </StyledUl>

                <Grid container direction={"column"} justifyContent={"center"} alignItems={"center"}>
                    <StyledPrice>{t('priceList.package.priceMonth3')}</StyledPrice>
                    {/*<StyledPrice>&nbsp;</StyledPrice>*/}
                    <StyledPrice>{t('priceList.package.priceYear3')}</StyledPrice>
                    <StyledButton type={"button"} color={"violet"} onClick={(event) => {setVipSubAnchorEl(event.currentTarget)}} disabled={(user?.subscription?.codename === 'publisherVipSubscriptionMonth' || user?.subscription?.codename === 'publisherVipSubscriptionYear')}>{t('priceList.orderButton')}</StyledButton>
                    <Menu
                        id="vip-sub-menu"
                        anchorEl={vipSubAnchorEl}
                        open={Boolean(vipSubAnchorEl)}
                        onClose={() => setVipSubAnchorEl(null)}
                    >
                        {user?.language === 'pl' &&
                            <MenuItem onClick={() => {requestPlan("publisherVipSubscriptionMonth", "online")}}>{t('priceList.payOnlineMonth')}</MenuItem>
                        }
                        <MenuItem onClick={() => {requestPlan("publisherVipSubscriptionMonth", "manual")}}>{t('priceList.payManualMonth')}</MenuItem>
                        {user?.language === 'pl' &&
                            <MenuItem onClick={() => {requestPlan("publisherVipSubscriptionYear", "online")}}>{t('priceList.payOnlineYear')}</MenuItem>
                        }
                        <MenuItem onClick={() => {requestPlan("publisherVipSubscriptionYear", "manual")}}>{t('priceList.payManualYear')}</MenuItem>
                    </Menu>
                    {(user?.subscription?.codename === 'publisherVipSubscriptionMonth' || user?.subscription?.codename === 'publisherVipSubscriptionYear') && user?.subscription?.billing_end &&
                    <StyledDateExpire>{t('priceList.subBillingEnd')}: {new Date(user?.subscription?.billing_end).toLocaleString()}</StyledDateExpire>
                    }
                </Grid>
            </Grid>
        </Grid>

        <SuccessModal open={success} setOpen={setSuccess} title={t('priceList.successModalTitle')} description={successDescription} buttonText={t('priceList.successModalButton')} buttonLink={'/dashboard'}/>
        </>
    );
}

export default PriceListPage;

const StyledTitle = styled('h3')`
  color: ${Colors.violet};
  font-weight: 600;
  text-align: center;
  font-size: 1.5rem;
  margin-top: 4rem;
`;

const StyledUl = styled('ul')`
  max-width: 300px;
  margin: 3rem auto 0;
`;

const StyledLi = styled('li')`
  list-style-type: disc;
  margin-bottom: 1rem;
  font-weight: 500;
  font-size: 0.9rem;
`;

const StyledLiNonActive = styled('li')`
  list-style-type: disc;
  color: #dddddd;
  margin-bottom: 1rem;
  font-size: 0.9rem;
`;

const StyledPrice = styled('p')`
  text-align: center;
  color: ${Colors.pink};
  font-weight: 600;
  font-size: 1.4rem;
  margin-bottom: 0.8rem;
`;

const StyledDateExpire = styled('p')`
  margin-top: 10px;
  font-weight: 500;
`;
